import {Injectable, signal} from "@angular/core";

@Injectable({ providedIn: 'root' })
export class LoaderService {

  loading = signal(false);
  message = signal<string>('Loading...');

  show(msg: string = 'Loading...') {
    this.message.set(msg);
    this.loading.set(true);
  }

  hide() {
    this.loading.set(false);
  }
}
